module.exports = __webpack_public_path__ + "img/hedgehog.c534ca4.png";